/**
 * class Tracking used for class playlist
 * @see playlist.js
 */
export default class Tracking {

    constructor(options) {
        this.videoId = options.videoId || '';
        this.videoName = options.videoName || '';
        this.region = options.region || '';
        this.bestellnummer = options.bestellnummer || null;
        this.adw = options.adw || false;
        this.adt = options.adt || false;
    }

    updateWithVideoData(videoData) {
        this.videoName = videoData.caption;
        this.videoId = videoData.videoId;
    }

    getCurrentTrackingData() {
        return {
            videoId: this.videoId,
            videoName: this.videoName,
            region: this.region,
            betellnummer: this.bestellnummer,
            adw: this.adw,
            adt: this.adt,
        };
    }
}